// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"8":"add10916f703353a43d1","208":"8784cea29e5bffd574a9","241":"a5893ebeec613cd05898","384":"57060573fcf2281897ba","657":"d28c8e0fc2f5fc1aa93e"}[chunkId] + ".js";
};